const imgTeamGraphic1HoverPoster1 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/0742553d-37fd-4197-a5b0-32f0c371bdff.png";
const img2026923372 = "./assets/figma/4035b339-96f6-4927-b1b2-b4d052e226e0.png";
const img2026923373 = "./assets/figma/23c7af17-4de0-4bc4-8324-06de9991695e.png";
const img12061 = "./assets/figma/00689bd6-b6e6-499a-a3c6-686dae57eabc.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/10c9e57a-3d9e-46bd-aa90-dd15d7868e23.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamGraphic1HoverPoster1() {
  return (
    <div className="s0 s1" data-node-id="886:1507" data-name="TEAM_GRAPHIC_1/HOVER_POSTER1">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s440 s441 s9 s10 s442" src={imgTeamGraphic1HoverPoster1} />
        </div>
      </div>
      <div className="s2 s12 s13 s443 s15" data-node-id="886:1509" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s238 s22" data-node-id="886:1510">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="886:1511">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1512">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="886:1513">
            <p className="s39 s40">
              POSTER · A2 · 2<br aria-hidden />
              BRAND BOOK · B5 · 1
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="886:1514">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="886:1515">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1516">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="886:1517">
            <p className="s39 s40">강지운</p>
            <p className="s39 s40">김세원</p>
            <p className="s39 s40">노아연</p>
            <p className="s39">정다혜</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s239 s54" data-node-id="886:1518">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s240 s57" data-node-id="886:1519">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="886:1520">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="886:1521">
          <p className="s39 s40">{`그래픽 1팀은 DING AI LAB의 Play Lab 콘셉트와 브랜드 시스템을 포스터와 브랜드북으로 시각화했다. `}</p>
          <p className="s39 s40">
            {`아이디어와 AI가 연결되고 실험되는 과정을 구슬과 투명한 파이프로 표현하고, Play·Flow·Connection·Modular의 네 가지 키워드를 중심으로 `}
            <br aria-hidden />
            {`일관된 브랜드 정체성을 구축했다. 브랜드북에는 8가지 AI별 Tube System과 응용 사례를 담았으며, 구슬이 튜브를 통과하면서 색·질감·형태를 `}
          </p>
          <p className="s39 s40">{`얻고 조합 순서에 따라 다른 결과로 발전하는 과정을 그래픽 시스템으로 구성했다. 오프화이트와 민트 계열의 색상, `}</p>
          <p className="s39">투명한 소재와 구조적인 레이아웃을 적용해 정돈된 실험실 분위기를 완성했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s943 s27 s29 s61 s241 s54" data-node-id="886:1522">
        GRAPHIC 1
      </p>
      <div className="s2 s16 s17 s24 s944 s18 s19 s20 s242 s66" data-node-id="886:1523">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="886:1524">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="886:1525">
          <a className="s141 s335 s336 s337 s338 s0 s28" data-node-id="886:1526">
            <div className="s244 s192 s245 s444 s445 s0 s70 s198 s248" data-node-id="886:1527" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
              </div>
            </div>
            <div className="s192 s69 s339 s340 s82 s4 s0 s70 s198 s146 s71" data-node-id="886:1529">
              <div aria-hidden className="s2 s3 s70" style={{ backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)" }} />
              <div className="s2 s3 s150 s151" />
            </div>
            <p className="s23 s192 s31 s249 s936 s459 s27 s0 s198 s251 s85 s138 s253 s54" data-node-id="886:1530">
              POSTER 1
            </p>
          </a>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="886:1531">
            <div className="s192 s69 s1062 s340 s0 s70 s198 s348 s71" data-node-id="886:1532" data-name="이미지 2026. 9. 2. 오후 3.37 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923372} />
              </div>
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:1534" />
          </div>
          <a className="s141 s335 s336 s337 s338 s0 s28" data-node-id="1026:448">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="1026:449" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s7 s948 s9 s10 s949" src={img2026923373} />
              </div>
            </div>
            <div className="s80 s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="1026:450" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="1026:451" />
          </a>
        </div>
      </div>
      <div className="s2 s951 s328 s240 s952" data-node-id="886:1541" data-name="이미지 1206 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12061} />
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="886:1542">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="886:1543" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="886:1544">
          <div className="s111 s0 s28 s112" data-node-id="886:1545" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="886:1550">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="886:1551">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="886:1552">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1553">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1554">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="886:1555">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1556">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1557">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="886:1558">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1559">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1560">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}